import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "user-body"
};
var _hoisted_2 = {
  class: "logo-body"
};
var _hoisted_3 = {
  class: "user-info"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "info-detail"
};
var _hoisted_6 = {
  class: "user-name ellipsis"
};
var _hoisted_7 = {
  style: {
    "margin-right": "4px"
  }
};
var _hoisted_8 = {
  class: "temperature"
};
var _hoisted_9 = {
  class: "weather"
};
var _hoisted_10 = {
  class: "weather-text ellipsis"
};
import RoleSwitchDialog from '../../Common/RoleSwitchDialog.vue';
import { getDefaultSchool, getCurrentWeather } from '@/api/home';
import { getSignOut } from '@/api/user.js';
import { appAliasEvent } from '@/utils/auth.js';
import { DialogPlugin } from 'tdesign-vue-next';
import { validateNull } from '@/util/validate';
import { clearStore } from '@/util/store';
import { onMounted, reactive, ref, computed } from 'vue';
import { skipUrl as skipUrlOpen, toLogin } from '@/util/util';
import useUserStore from '@/stores/modules/user';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
export default {
  __name: 'UserInfo',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var _storeToRefs = storeToRefs(userStore),
      userInfo = _storeToRefs.userInfo,
      accountInfo = _storeToRefs.accountInfo,
      currentRole = _storeToRefs.currentRole,
      token = _storeToRefs.token;
    var avatar = require('@/assets/defaultAvatar1.png');
    var router = useRouter();

    /* 常量 */
    // 天气
    var weatherType = {
      CLEAR_DAY: {
        icon: 'clear-day',
        text: '晴天'
      },
      // 晴（白天）
      CLEAR_NIGHT: {
        icon: 'clear-night',
        text: '晴天'
      },
      // 晴（夜间）
      PARTLY_CLOUDY_DAY: {
        icon: 'partly-cloudy-day',
        text: '多云'
      },
      // 多云（白天）
      PARTLY_CLOUDY_NIGHT: {
        icon: 'partly-cloudy-night',
        text: '多云'
      },
      // 多云（夜间）
      CLOUDY: {
        icon: 'cloudy',
        text: '阴'
      },
      // 阴
      WIND: {
        icon: 'wind',
        text: '大风'
      },
      // 大风
      LIGHT_RAIN: {
        icon: 'light-rain',
        text: '小雨'
      },
      // 小雨
      MODERATE_RAIN: {
        icon: 'moderate-rain',
        text: '中雨'
      },
      // 中雨
      HEAVY_RAIN: {
        icon: 'heavy-rain',
        text: '大雨'
      },
      // 大雨
      STORM_RAIN: {
        icon: 'storm-rain',
        text: '暴雨'
      },
      // 暴雨
      LIGHT_SNOW: {
        icon: 'light-snow',
        text: '小雪'
      },
      // 小雪
      MODERATE_SNOW: {
        icon: 'moderate-snow',
        text: '中雪'
      },
      // 中雪
      HEAVY_SNOW: {
        icon: 'heavy-snow',
        text: '大雪'
      },
      // 大雪
      STORM_SNOW: {
        icon: 'storm-snow',
        text: '暴雪'
      },
      // 暴雪
      LIGHT_HAZE: {
        icon: 'haze',
        text: '轻度雾霾'
      },
      // 轻度雾霾
      MODERATE_HAZE: {
        icon: 'haze',
        text: '中度雾霾'
      },
      // 中度雾霾
      HEAVY_HAZE: {
        icon: 'haze',
        text: '重度雾霾'
      },
      // 重度雾霾
      FOG: {
        icon: 'fog',
        text: '雾'
      },
      // 雾
      SAND: {
        icon: 'fog',
        text: '沙尘'
      },
      // 沙尘
      DUST: {
        icon: 'fog',
        text: '浮尘'
      } //浮尘
    };

    /* 变量 */
    var stateInfo = reactive({
      headImg: '',
      // 头像
      userName: '',
      // 用户名
      institutionName: '',
      // 职位
      weatherText: '',
      // 天气
      weatherQuailty: '轻度污染',
      //空气质量
      weatherIcon: '',
      // 天气code
      temperature: null // 温度
    });
    var showRoleSwitch = ref(false);

    /**
     * 身份显示
     */
    var identity = computed(function () {
      if (validateNull(currentRole.value)) return '--';
      return {
        manager: '管理员',
        teacher: '教师',
        student: '学生'
      }[currentRole.value];
    });
    // 根据id获取用户信息
    var getIdUser = function getIdUser(userItem) {
      if (validateNull(userItem)) return;
      stateInfo.headImg = userItem.avatar || avatar;
      stateInfo.userName = userItem.name || userItem.nickname;
      stateInfo.institutionName = userItem.institutionName;
    };
    // 获取默认学校信息
    var getDefSchool = function getDefSchool() {
      return new Promise(function (resolve) {
        getDefaultSchool().then(function (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          } else {
            resolve(false);
          }
        }).catch(function (err) {
          resolve(false);
        });
      });
    };
    // 获取当前天气信息
    var getCurWeather = function getCurWeather(info) {
      var data = {
        address: info.provinceName + info.cityName + info.areaName,
        areaCode: info.areaCode.slice(0, 6),
        institutionId: info.id
      };
      getCurrentWeather(data).then(function (res) {
        if (res.data.code === 0) {
          var _data = res.data.data;
          stateInfo.weather = _data === null || _data === void 0 ? void 0 : _data.skyconName.split('（')[0];
          if (!validateNull(_data.skyconCode)) {
            var skyconCode = _data.skyconCode || 'CLEAR_DAY';
            var weatherObj = weatherType[skyconCode];
            stateInfo.weatherIcon = weatherObj.icon;
            stateInfo.weatherText = weatherObj.text;
          }
          stateInfo.temperature = _data.temperature;
        }
      });
    };
    onMounted(function () {
      initData();
    });

    /**
     * 初始化数据
     */
    var initData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var schoolInfo;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              userInfo.value && getIdUser(userInfo.value);
              if (!(accountInfo.value.accountType !== 2)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getDefSchool();
            case 1:
              schoolInfo = _context.v;
              schoolInfo && getCurWeather(schoolInfo);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function initData() {
        return _ref.apply(this, arguments);
      };
    }();

    //退出
    var handleLogout = function handleLogout() {
      var DialogInstance = DialogPlugin.confirm({
        theme: 'warning',
        header: '是否确认退出？',
        confirmBtn: '是',
        cancelBtn: '否',
        onConfirm: function () {
          var _onConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  getSignOut().then(function (res) {
                    if (res.data.code === 0) {
                      DialogInstance.destroy();
                      clearStore();
                      toLogin();
                    }
                  });
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          function onConfirm() {
            return _onConfirm.apply(this, arguments);
          }
          return onConfirm;
        }()
      });
    };
    //跳转个人中心
    var handleCenter = function handleCenter() {
      router.push('/accountInfo');
    };
    //跳转天气
    var goWeather = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var appUrl, url;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return appAliasEvent('weather');
            case 1:
              appUrl = _context3.v;
              url = "".concat(appUrl, "?token=").concat(token.value);
              skipUrlOpen(url);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function goWeather() {
        return _ref2.apply(this, arguments);
      };
    }();

    /**
     * 切换角色
     */
    var handleRoleSwitch = function handleRoleSwitch() {
      showRoleSwitch.value = true;
    };
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "logo",
        size: "24"
      }), _createElementVNode("span", null, _toDisplayString(stateInfo.institutionName), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "avatar",
        src: stateInfo.headImg,
        alt: "",
        onClick: handleCenter
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(stateInfo.userName), 1), _createElementVNode("div", {
        class: "user-identity",
        onClick: handleRoleSwitch
      }, [_createElementVNode("span", _hoisted_7, _toDisplayString(identity.value), 1), _createVNode(_component_svg_icon, {
        name: "swap",
        size: "10"
      })])]), _createElementVNode("div", {
        class: "weather-info",
        onClick: goWeather
      }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(stateInfo.weatherQuailty), 1), _createElementVNode("span", null, _toDisplayString(stateInfo.temperature) + " °C", 1)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_svg_icon, {
        name: stateInfo.weatherIcon
      }, null, 8, ["name"]), _createElementVNode("span", _hoisted_10, _toDisplayString(stateInfo.weatherText), 1), _createElementVNode("div", {
        class: "logout",
        onClick: _withModifiers(handleLogout, ["stop"])
      }, [_createVNode(_component_svg_icon, {
        name: "logout"
      })])])])]), _createVNode(RoleSwitchDialog, {
        visible: showRoleSwitch.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return showRoleSwitch.value = $event;
        })
      }, null, 8, ["visible"])]);
    };
  }
};